import {
    BetBuilderOdd,
    BetBuilderOddStatus,
} from '../types/BetBuilderOdd';
import { BetBuilderLeg } from '../types/BetBuilderPreview';

export function keepActiveOdds(selectedOdds: BetBuilderOdd['uuid'][], legs: BetBuilderLeg[]): BetBuilderOdd['uuid'][] {
    return selectedOdds.filter((uuid) => {
        return legs.find((leg) => leg.uuid === uuid)?.status === BetBuilderOddStatus.Active;
    });
}
